import { RootState } from '@app/redux/root-reducer';

export const selectDepartmentState = (store: RootState) => store.departmentsReducer.departments;

export const selectDeleteDepartmentState = (state: RootState) =>
  state.departmentsReducer.deleteDepartment;

export const selectAddDepartmentState = (store: RootState) =>
  store.departmentsReducer.addDepartment;
